import { __assign } from "tslib";
import { useContext } from 'react';
import { createDomContext } from '../hooks/dom-context';
export var FormFieldDomContext = createDomContext('form-field-context', {});
export function useFormFieldContext(props) {
    var context = useContext(FormFieldDomContext.context);
    return __assign(__assign({}, context), props);
}
//# sourceMappingURL=form-field-context.js.map